<script>
import usernameIcon from './assets/login_username.svg'
import passwordIcon from './assets/login_password.svg'
export default {
    props: {
        type: String,
        value: {}
    },
    data() {
        return {
            focused: false
        }
    },
    computed: {
        icon() {
            if (this.type == 'username') {
                return usernameIcon
            } else {
                return passwordIcon
            }
        },
        placeholder() {
            if (this.type == 'username') {
                return '账号'
            } else {
                return '密码'
            }
        },
        inputType() {
            if (this.type == 'username') {
                return 'text'
            } else {
                return 'password'
            }
        }
    },
    methods: {
        input(value) {
            this.$emit('input', value)
        },
        clear() {
            this.input('')
        }
    }
}
</script>

<template>
    <div class="LoginInput" :class="{focused: focused}">
        <img class="icon" :src="icon" alt="">
        <input :placeholder="placeholder" :type="inputType" :value="value" @input="input($event.target.value)" @focus="focused = true" @blur="focused = false" >
        <img v-show="value" class="clear" @click="clear" src="./assets/clear_close.svg">
    </div>
</template>

<style lang="scss" scoped>
@import './css/color.scss';
.LoginInput {
    display: flex;
    align-items: center;
    height: 32px;
    box-sizing: border-box;
    border-bottom: 1px solid #EEEEEE;
    width: 240px;
    >input {
        margin-left: 8px;
        flex-grow: 1;
        border: none;
        outline: none;
        font-size: 14px;
        background-color: transparent;
        &:-webkit-autofill {
            box-shadow: 0 0 0 30px #F5F6F7 inset;
        }
    }
    .clear {
        cursor: pointer;
    }
}
.focused {
    border-color: $mainPurple;
    transition: border-color 0.3s;
}
</style>




// WEBPACK FOOTER //
// yotta-vue-components/vision/LoginInput.vue